module.exports = __webpack_public_path__ + "img/ico_phone-call.bf58942e.svg";